import React from "react";
import chrome_browser from "../../../assets/images/chrome.png";
import edge_browser from "../../../assets/images/edge.png";
import firefox_browser from "../../../assets/images/firefox.png";
import opera_browser from "../../../assets/images/opera.png";
import { StyledUnsupportedVersionBrowser } from "../../styled/unsupportedBrowser";

export default function UnsupportedVersionBrowser({
  browser,
  browserName,
  version,
  minVersion,
}) {
  return (
    <StyledUnsupportedVersionBrowser.Center>
      <StyledUnsupportedVersionBrowser.Root>
        <p>
          El navegador que utiliza, <b>{browserName}</b>, no supera la versión
          mínima requerida para usar <b>ml.point</b>
          <br />
          <br />
          Le sugerimos actualizar su navegador a fin de poder utilizar la
          aplicación.
          <br />
          <br />
        </p>
        <StyledUnsupportedVersionBrowser.Container>
          <StyledUnsupportedVersionBrowser.Browser>
            <img
              src={
                {
                  "edge-chromium": edge_browser,
                  chrome: chrome_browser,
                  firefox: firefox_browser,
                  opera: opera_browser,
                }[browser]
              }
              alt={browserName}
              title={browserName}
              width="80"
              height="80"
            />
            <div>
              <StyledUnsupportedVersionBrowser.Link
                href={
                  {
                    "edge-chromium": "https://www.microsoft.com/es-es/edge/",
                    edge: "https://www.microsoft.com/es-es/edge/",
                    chrome: "https://www.google.com/intl/es/chrome/",
                    firefox: "https://www.mozilla.org/es-ES/",
                    opera: "https://www.opera.com/es/",
                  }[browser]
                }
                target="_blank"
                rel="noreferrer">
                {browser === "edge" ? browserName + "(Chromium)" : browserName}
              </StyledUnsupportedVersionBrowser.Link>
              <div>
                <br />
                <StyledUnsupportedVersionBrowser.VersionContainer>
                  <div>
                    Su versión:
                    <StyledUnsupportedVersionBrowser.BrowserVersion>
                      {" "}
                      {browser !== "edge-chromium" ? version : browserName}
                    </StyledUnsupportedVersionBrowser.BrowserVersion>
                  </div>
                  <div>
                    Versión mínima:
                    <StyledUnsupportedVersionBrowser.BrowserMinVersion>
                      {" "}
                      {browser !== "edge-chromium"
                        ? minVersion
                        : browserName}{" "}
                      (Chromium)
                    </StyledUnsupportedVersionBrowser.BrowserMinVersion>
                  </div>
                </StyledUnsupportedVersionBrowser.VersionContainer>
              </div>
            </div>
          </StyledUnsupportedVersionBrowser.Browser>
        </StyledUnsupportedVersionBrowser.Container>
      </StyledUnsupportedVersionBrowser.Root>
    </StyledUnsupportedVersionBrowser.Center>
  );
}
